import React from "react";
import PropTypes from "prop-types";
import Badge from "../../../../components/common/Badge";
import {
  COMMERCIAL_MODEL,
  DISTRIBUTION,
  DISTRIBUTION_LABELS,
} from "../constants";
import "./DistributionTypeBadge.scss";

// Keyed off DISTRIBUTION, not COMMERCIAL_MODEL — this badge renders a
// distribution value. The three original keys are identical strings, so the
// re-key is a no-op. Variants must stay inside BADGE_VARIANTS
// (components/common/Badge.jsx). Prebuy keeps "success" as its base variant;
// the commercial-model modifier below overrides its colours.
const variantByType = {
  [DISTRIBUTION.COMMUNITY]: "info",
  [DISTRIBUTION.EXCLUSIVE]: "warning",
  [DISTRIBUTION.DIRECT]: "primary",
  [DISTRIBUTION.PREBUY]: "success",
};

// Prebuy is the one distribution that pairs with BOTH commercial models, so it
// gets two colours — otherwise an open Community Prebuy rate is
// indistinguishable from a client-restricted Direct Prebuy rate. Every other
// distribution ignores the model.
const prebuyModifier = (commercialModel) =>
  commercialModel === COMMERCIAL_MODEL.DIRECT
    ? "distribution-badge--prebuy-direct"
    : "distribution-badge--prebuy-community";

const DistributionTypeBadge = ({ type, commercialModel }) => {
  const variant = variantByType[type];
  if (!variant) return "-";
  return (
    <Badge
      variant={variant}
      className={
        type === DISTRIBUTION.PREBUY
          ? prebuyModifier(commercialModel)
          : undefined
      }
    >
      {DISTRIBUTION_LABELS[type]}
    </Badge>
  );
};

DistributionTypeBadge.propTypes = {
  type: PropTypes.string,
  commercialModel: PropTypes.string,
};

export default DistributionTypeBadge;
